import { render, staticRenderFns } from "./ArtificialAgent.vue?vue&type=template&id=b53ebb4e&scoped=true"
import script from "./ArtificialAgent.vue?vue&type=script&lang=js"
export * from "./ArtificialAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53ebb4e",
  null
  
)

export default component.exports